<div class="st-page">
  <a class="st-back-link" (click)="goBack()"><i class="ri-arrow-left-line"></i> {{ 'backToClass' | translate }}</a>

  <div class="st-page-head">
    <div>
      <h1 class="st-title">{{ 'activity' | translate }}</h1>
      <p class="st-subtitle">{{ 'classSocialFeedForParents' | translate }}</p>
    </div>
  </div>

  <div class="sca-layout">
    <div class="sca-feed-col">
      <div class="st-card sca-post-card sca-skeleton-card" *ngIf="loading">
        <div class="sca-post-head">
          <div class="st-avatar sca-post-avatar sca-skeleton sca-skeleton-circle"></div>
          <div class="st-list-text">
            <div class="sca-skeleton sca-skeleton-line sca-skeleton-line-title"></div>
            <div class="sca-skeleton sca-skeleton-line sca-skeleton-line-sub"></div>
          </div>
        </div>
        <div class="sca-skeleton sca-skeleton-line sca-skeleton-line-text"></div>
        <div class="sca-skeleton sca-skeleton-line sca-skeleton-line-text-short"></div>
        <div class="sca-skeleton sca-skeleton-media"></div>
      </div>
      <div class="st-card sca-post-card sca-skeleton-card" *ngIf="loading">
        <div class="sca-post-head">
          <div class="st-avatar sca-post-avatar sca-skeleton sca-skeleton-circle"></div>
          <div class="st-list-text">
            <div class="sca-skeleton sca-skeleton-line sca-skeleton-line-title"></div>
            <div class="sca-skeleton sca-skeleton-line sca-skeleton-line-sub"></div>
          </div>
        </div>
        <div class="sca-skeleton sca-skeleton-line sca-skeleton-line-text"></div>
        <div class="sca-skeleton sca-skeleton-line sca-skeleton-line-text-short"></div>
      </div>
      <div class="st-card sca-post-card sca-skeleton-card" *ngIf="loading">
        <div class="sca-post-head">
          <div class="st-avatar sca-post-avatar sca-skeleton sca-skeleton-circle"></div>
          <div class="st-list-text">
            <div class="sca-skeleton sca-skeleton-line sca-skeleton-line-title"></div>
            <div class="sca-skeleton sca-skeleton-line sca-skeleton-line-sub"></div>
          </div>
        </div>
        <div class="sca-skeleton sca-skeleton-line sca-skeleton-line-text"></div>
        <div class="sca-skeleton sca-skeleton-media"></div>
      </div>

      <div class="st-empty-state" *ngIf="!loading && loadError">
        <i class="ri-error-warning-line"></i> {{ 'couldntLoadActivityFeed' | translate }}
      </div>

      <div class="st-empty-state" *ngIf="!loading && !loadError && posts.length === 0">
        <i class="ri-image-line"></i> {{ 'noActivityPostsYet' | translate }}
      </div>

      <div class="st-card sca-post-card" *ngFor="let post of posts">
        <div class="sca-post-head">
          <div class="st-avatar sca-post-avatar">
            <img *ngIf="postAuthorImage(post)" [src]="postAuthorImage(post)" alt="" />
            <ng-container *ngIf="!postAuthorImage(post)">{{ postAuthor(post).charAt(0) }}</ng-container>
          </div>
          <div class="st-list-text">
            <div class="sca-post-title">{{ postAuthor(post) }}</div>
            <div class="sca-post-meta">{{ 'postedLabel' | translate }} {{ postTime(post) }}</div>
          </div>
          <div class="sca-post-menu" *ngIf="canEditPost(post) || canDeletePost(post)">
            <button class="sca-icon-btn" *ngIf="canEditPost(post)" (click)="openEditComposer(post)" title="{{ 'edit' | translate }}"><i class="ri-pencil-line"></i></button>
            <button class="sca-icon-btn" *ngIf="canDeletePost(post)" (click)="deletePost(post)" title="{{ 'deleteAction' | translate }}"><i class="ri-delete-bin-line"></i></button>
          </div>
        </div>

        <div class="sca-post-text" [innerHTML]="postBodyHtml(post)"></div>

        <div class="sca-link-preview" *ngIf="postLink(post) as link" (click)="openLinkLightbox(link)">
          <div class="sca-link-thumb" *ngIf="linkPreview(link).isYouTube">
            <img [src]="linkPreview(link).thumbnail" alt="" />
            <div class="sca-link-play"><i class="ri-play-line"></i></div>
          </div>
          <div class="sca-link-thumb sca-link-thumb-generic" *ngIf="!linkPreview(link).isYouTube">
            <i class="ri-link"></i>
          </div>
          <div class="sca-link-info">
            <div class="sca-link-domain">{{ linkPreview(link).domain }}</div>
            <div class="sca-link-url">{{ link }}</div>
          </div>
        </div>

        <div class="sca-media-collage" *ngIf="hasMedia(post)" [class.sca-single-media]="!isCollage(post)" [ngClass]="isCollage(post) ? ('sca-collage-' + Math.min(visualMediaCount(post), 4)) : ''">
          <ng-container *ngFor="let m of allVisualMedia(post).slice(0,4); let i = index">
            <div class="sca-collage-tile" (click)="(i === 3 && extraMediaCount(post) > 0) ? openGallery(post) : openMediaPreview(m)">
              <img *ngIf="m.mediaType === 'IMAGE'" [src]="m.mediaUrl" class="sca-collage-img" alt="" />
              <video *ngIf="m.mediaType === 'VIDEO'" [src]="m.mediaUrl" class="sca-collage-img"></video>
              <div class="sca-collage-more-overlay" *ngIf="i === 3 && extraMediaCount(post) > 0">
                +{{ extraMediaCount(post) }}
              </div>
            </div>
          </ng-container>
        </div>
        <div class="sca-media-doc-row" *ngIf="postDocuments(post).length">
          <ng-container *ngFor="let d of postDocuments(post)">
            <a *ngIf="isPdfDocument(d) && pdfThumbnail(d.mediaUrl) as thumb; else docChip"
               (click)="openDocumentLightbox(d.mediaUrl)" href="javascript:void(0)" class="sca-media-doc-thumb">
              <img [src]="thumb" alt="{{ 'documentPreview' | translate }}" />
              <span class="sca-media-doc-thumb-label"><i class="ri-file-pdf-line"></i> {{ 'document' | translate }}</span>
            </a>
            <ng-template #docChip>
              <a (click)="openDocumentLightbox(d.mediaUrl)" href="javascript:void(0)" class="sca-media-doc-chip">
                <i class="ri-file-pdf-line"></i> {{ 'document' | translate }}
              </a>
            </ng-template>
          </ng-container>
        </div>

        <div class="sca-reaction-summary" *ngIf="postTotalLikes(post)" (click)="openReactionList(post)">
          <span class="sca-reaction-icons">
            <span *ngFor="let icon of reactionIcons(post)">{{ icon }}</span>
          </span>
          {{ reactionSummaryText(post) }}
        </div>

        <div class="sca-post-footer">
          <div class="sca-reaction-wrap">
            <span class="sca-footer-stat" [class.sca-footer-stat-disabled]="!activityLikeEnabled" (click)="activityLikeEnabled && toggleReactionPicker(post)">
              <ng-container *ngIf="myReactionIcon(post) as icon; else defaultIcon">{{ icon }}</ng-container>
              <ng-template #defaultIcon><i [ngClass]="defaultReactionIcon"></i></ng-template>
              {{ postTotalLikes(post) }}
            </span>
            <div class="sca-reaction-picker" *ngIf="activityLikeEnabled && openReactionPickerId === post.activityId">
              <button class="sca-reaction-option" *ngFor="let r of reactions" [class.active]="isReactedByMe(post, r.slug)" (click)="reactToPost(post, r.slug)" title="{{ r.label }}">
                {{ r.icon }}
              </button>
            </div>
          </div>
          <span class="sca-footer-stat" *ngIf="getCommentEnabled" (click)="openCommentSheet(post)">
            <i class="ri-chat-3-line"></i> {{ postCommentCount(post) }}
          </span>
        </div>
      </div>

      <div class="sca-load-more" *ngIf="!loading && posts.length && pageNumber < maxPageNumber">
        <button class="st-btn st-btn-secondary" [disabled]="loadingMore" (click)="loadMore()">
          {{ (loadingMore ? 'loadingEllipsis' : 'loadMore') | translate }}
        </button>
      </div>
    </div>

    <div class="sca-composer-col sca-composer-col-disabled" *ngIf="!createActivityEnabled">
      <div class="st-card sca-composer-card sca-composer-disabled">
        <i class="ri-lock-line"></i>
        <p>{{ 'notAllowedToCreateActivityPost' | translate }}</p>
      </div>
    </div>

    <div class="sca-composer-col" *ngIf="createActivityEnabled">
      <div class="st-card sca-composer-card">
        <h3 class="sca-composer-title">{{ 'shareAnUpdate' | translate }}</h3>
        <textarea class="sca-inline-textarea" rows="6" placeholder="{{ 'whatHappenedInClassToday' | translate }}" [(ngModel)]="composerText"></textarea>

        <!-- Only a super admin may author a school-wide post; every other
             staff member is locked to class-level, with no selector shown
             at all since there's no actual choice to make. -->
        <div class="sca-level-row" *ngIf="isSuperAdmin">
          <label class="sca-radio">
            <input type="radio" name="level" value="CLASS" [(ngModel)]="composerLevel" /> {{ 'thisClassOnly' | translate }}
          </label>
          <label class="sca-radio">
            <input type="radio" name="level" value="SCHOOL" [(ngModel)]="composerLevel" /> {{ 'wholeSchool' | translate }}
          </label>
        </div>

        <label class="sca-file-dropzone" [class.sca-file-dropzone-active]="isDraggingOverComposer"
               (dragover)="onComposerDragOver($event)" (dragleave)="onComposerDragLeave($event)" (drop)="onComposerFilesDropped($event)">
          <div class="sca-file-dropzone-icon"><i class="ri-upload-cloud-2-line"></i></div>
          <div class="sca-file-dropzone-text">
            <strong>{{ 'clickToUpload' | translate }}</strong> {{ 'orDragAndDrop' | translate }}
          </div>
          <div class="sca-file-dropzone-hint">{{ 'pngJpgUpToFewMb' | translate }}</div>
          <input type="file" multiple accept="image/*" (change)="onFilesSelected($event)" hidden />
        </label>

        <div class="sca-edit-media-grid" *ngIf="composerFiles.length">
          <div class="sca-edit-media-item" *ngFor="let preview of composerFilePreviews; let i = index">
            <img [src]="preview" alt="" />
            <button class="sca-edit-media-remove" (click)="removeSelectedFile(i)" title="{{ 'remove' | translate }}">
              <i class="ri-close-line"></i>
            </button>
          </div>
        </div>

        <button class="sca-post-btn" [disabled]="submittingPost" (click)="submitInlinePost()">
          {{ (submittingPost ? 'postingEllipsis' : 'postToClassFeed') | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Edit post side panel -->
<div class="sca-drawer-overlay" *ngIf="showComposer" (click)="closeComposer()">
  <div class="sca-drawer" (click)="$event.stopPropagation()">
    <div class="sca-drawer-head">
      <h3>{{ 'editPostTitle' | translate }}</h3>
      <button class="sca-icon-btn" (click)="closeComposer()"><i class="ri-close-line"></i></button>
    </div>
    <div class="sca-drawer-body">
      <div class="sca-drawer-section">
        <label class="sca-drawer-label">{{ 'description' | translate }}</label>
        <textarea class="sca-composer-textarea" rows="8" placeholder="{{ 'shareSomethingWithParents' | translate }}" [(ngModel)]="editText"></textarea>
      </div>

      <div class="sca-drawer-section" *ngIf="editingExistingMedia.length">
        <label class="sca-drawer-label">{{ 'currentAttachments' | translate }}</label>
        <div class="sca-edit-media-grid">
          <div class="sca-edit-media-item" *ngFor="let m of editingExistingMedia">
            <img *ngIf="m.mediaType === 'IMAGE'" [src]="m.mediaUrl" alt="" (click)="openMediaPreview(m)" />
            <video *ngIf="m.mediaType === 'VIDEO'" [src]="m.mediaUrl" (click)="openMediaPreview(m)"></video>
            <ng-container *ngIf="m.mediaType === 'DOCUMENT'">
              <img *ngIf="isPdfDocument(m) && pdfThumbnail(m.mediaUrl) as thumb" [src]="thumb" alt="{{ 'documentPreview' | translate }}" (click)="openDocumentLightbox(m.mediaUrl)" />
              <div class="sca-edit-media-doc" *ngIf="!isPdfDocument(m) || !pdfThumbnail(m.mediaUrl)" (click)="openDocumentLightbox(m.mediaUrl)">
                <i class="ri-file-pdf-line"></i>
              </div>
            </ng-container>
            <button class="sca-edit-media-remove" (click)="removeExistingMedia(m)" title="{{ 'remove' | translate }}">
              <i class="ri-close-line"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="sca-drawer-section">
        <label class="sca-drawer-label">{{ 'addNewPhotos' | translate }}</label>
        <label class="sca-file-dropzone" [class.sca-file-dropzone-active]="isDraggingOverEdit"
               (dragover)="onEditDragOver($event)" (dragleave)="onEditDragLeave($event)" (drop)="onEditFilesDropped($event)">
          <div class="sca-file-dropzone-icon"><i class="ri-upload-cloud-2-line"></i></div>
          <div class="sca-file-dropzone-text">
            <strong>{{ 'clickToUpload' | translate }}</strong> {{ 'orDragAndDrop' | translate }}
          </div>
          <div class="sca-file-dropzone-hint">{{ 'pngJpgUpToFewMb' | translate }}</div>
          <input type="file" multiple accept="image/*" (change)="onEditFilesSelected($event)" hidden />
        </label>

        <div class="sca-edit-media-grid" *ngIf="editFiles.length">
          <div class="sca-edit-media-item" *ngFor="let preview of editFilePreviews; let i = index">
            <img [src]="preview" alt="" />
            <button class="sca-edit-media-remove" (click)="removeEditFile(i)" title="{{ 'remove' | translate }}">
              <i class="ri-close-line"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="sca-drawer-foot">
      <button class="st-btn st-btn-secondary" (click)="closeComposer()">{{ 'cancel' | translate }}</button>
      <button class="st-btn st-btn-primary" [disabled]="submittingEdit" (click)="submitPost()">
        {{ (submittingEdit ? 'savingEllipsis' : 'saveChanges') | translate }}
      </button>
    </div>
  </div>
</div>

<!-- Delete-confirm modal — shown when deleting your own post -->
<div class="sca-modal-overlay" *ngIf="showDeleteConfirmModal" (click)="closeDeleteConfirmModal()">
  <div class="sca-modal sca-delete-modal" (click)="$event.stopPropagation()">
    <div class="sca-modal-head">
      <h3>{{ 'deleteActivityPostTitle' | translate }}</h3>
      <button class="sca-icon-btn" [disabled]="deletingPost" (click)="closeDeleteConfirmModal()"><i class="ri-close-line"></i></button>
    </div>
    <div class="sca-modal-body">
      <div class="sca-delete-warning-icon"><i class="ri-error-warning-line"></i></div>
      <p class="sca-delete-warning-text">{{ 'sureDeletePost' | translate }}</p>
      <p class="sca-delete-reason-hint">{{ 'deleteCannotBeUndone' | translate }}</p>
    </div>
    <div class="sca-modal-foot">
      <button class="st-btn st-btn-secondary" [disabled]="deletingPost" (click)="closeDeleteConfirmModal()">{{ 'cancel' | translate }}</button>
      <button class="st-btn st-btn-danger" [disabled]="deletingPost" (click)="confirmDelete()">
        <i class="ri-loader-4-line ri-spin" *ngIf="deletingPost"></i> {{ (deletingPost ? 'deletingEllipsis' : 'deletePostBtn') | translate }}
      </button>
    </div>
  </div>
</div>

<!-- Delete comment confirmation — opened from within the comment sheet,
     so it must stack above it (both overlays otherwise share the same
     z-index and DOM/source order would put the comment sheet on top). -->
<div class="sca-modal-overlay sca-modal-overlay-top" *ngIf="showDeleteCommentModal" (click)="closeDeleteCommentModal()">
  <div class="sca-modal sca-delete-modal" (click)="$event.stopPropagation()">
    <div class="sca-modal-head">
      <h3>{{ 'deleteCommentTitle' | translate }}</h3>
      <button class="sca-icon-btn" [disabled]="deletingComment" (click)="closeDeleteCommentModal()"><i class="ri-close-line"></i></button>
    </div>
    <div class="sca-modal-body">
      <div class="sca-delete-warning-icon"><i class="ri-error-warning-line"></i></div>
      <p class="sca-delete-warning-text">{{ 'sureDeleteComment' | translate }}</p>
      <p class="sca-delete-reason-hint">{{ 'deleteCannotBeUndone' | translate }}</p>
    </div>
    <div class="sca-modal-foot">
      <button class="st-btn st-btn-secondary" [disabled]="deletingComment" (click)="closeDeleteCommentModal()">{{ 'cancel' | translate }}</button>
      <button class="st-btn st-btn-danger" [disabled]="deletingComment" (click)="confirmDeleteComment()">
        <i class="ri-loader-4-line ri-spin" *ngIf="deletingComment"></i> {{ (deletingComment ? 'deletingEllipsis' : 'deleteCommentBtn') | translate }}
      </button>
    </div>
  </div>
</div>

<!-- Delete-reason modal — required when deleting a post someone else created -->
<div class="sca-modal-overlay" *ngIf="showDeleteReasonModal" (click)="closeDeleteReasonModal()">
  <div class="sca-modal sca-delete-modal" (click)="$event.stopPropagation()">
    <div class="sca-modal-head">
      <h3>{{ 'deleteActivityPostTitle' | translate }}</h3>
      <button class="sca-icon-btn" [disabled]="deletingPost" (click)="closeDeleteReasonModal()"><i class="ri-close-line"></i></button>
    </div>
    <div class="sca-modal-body">
      <div class="sca-delete-warning-icon"><i class="ri-error-warning-line"></i></div>
      <p class="sca-delete-reason-instructions">{{ 'postCreatedBySomeoneElseReason' | translate }}</p>
      <textarea class="sca-composer-textarea" rows="3" placeholder="{{ 'reasonForDeletionPlaceholder' | translate }}" [(ngModel)]="deleteReasonText"></textarea>
    </div>
    <div class="sca-modal-foot">
      <button class="st-btn st-btn-secondary" [disabled]="deletingPost" (click)="closeDeleteReasonModal()">{{ 'cancel' | translate }}</button>
      <button class="st-btn st-btn-danger" [disabled]="!deleteReasonText.trim() || deletingPost" (click)="confirmDeleteWithReason()">
        <i class="ri-loader-4-line ri-spin" *ngIf="deletingPost"></i> {{ (deletingPost ? 'deletingEllipsis' : 'deletePostBtn') | translate }}
      </button>
    </div>
  </div>
</div>

<!-- Reaction list modal -->
<div class="sca-modal-overlay" *ngIf="showReactionList" (click)="closeReactionList()">
  <div class="sca-modal" (click)="$event.stopPropagation()">
    <div class="sca-modal-head">
      <h3>{{ 'reactionsTitle' | translate }}</h3>
      <button class="sca-icon-btn" (click)="closeReactionList()"><i class="ri-close-line"></i></button>
    </div>
    <div class="sca-reaction-filter-row">
      <button class="sca-filter-chip" [class.active]="reactionListFilter === 'ALL'" (click)="setReactionFilter('ALL')">{{ 'all' | translate }}</button>
      <button class="sca-filter-chip" [class.active]="reactionListFilter === 'like'" (click)="setReactionFilter('like')">👍 {{ reactionStats.like }}</button>
      <button class="sca-filter-chip" [class.active]="reactionListFilter === 'love'" (click)="setReactionFilter('love')">❤️ {{ reactionStats.love }}</button>
      <button class="sca-filter-chip" [class.active]="reactionListFilter === 'laugh'" (click)="setReactionFilter('laugh')">😄 {{ reactionStats.laugh }}</button>
      <button class="sca-filter-chip" [class.active]="reactionListFilter === 'celebration'" (click)="setReactionFilter('celebration')">🎉 {{ reactionStats.celebration }}</button>
    </div>
    <div class="sca-modal-body">
      <ng-container *ngIf="reactionListLoading && reactionEntries.length === 0">
        <div class="st-list-row" *ngFor="let i of [1,2,3,4]">
          <div class="sca-skeleton sca-skeleton-circle" style="width:38px;height:38px;"></div>
          <div class="st-list-text">
            <div class="sca-skeleton sca-skeleton-line sca-skeleton-line-title"></div>
            <div class="sca-skeleton sca-skeleton-line sca-skeleton-line-sub"></div>
          </div>
        </div>
      </ng-container>
      <div class="st-list-row" *ngFor="let r of reactionEntries">
        <div class="st-avatar">
          <img *ngIf="r.likedByUserImage" [src]="r.likedByUserImage" alt="" />
          <ng-container *ngIf="!r.likedByUserImage">{{ r.likedByUserName.charAt(0) }}</ng-container>
        </div>
        <div class="st-list-text">
          <div class="st-list-title">{{ r.likedByUserName }}</div>
          <div class="st-list-sub">{{ r.likedByUserDesignation }}</div>
        </div>
      </div>
      <div class="st-empty-state" *ngIf="!reactionListLoading && reactionEntries.length === 0">{{ 'noReactionsYet' | translate }}</div>
    </div>
  </div>
</div>

<!-- Comment sheet -->
<div class="sca-modal-overlay" *ngIf="showComments" (click)="closeCommentSheet()">
  <div class="sca-modal sca-comment-sheet" (click)="$event.stopPropagation()">
    <div class="sca-modal-head">
      <h3>{{ 'comments' | translate }}</h3>
      <button class="sca-icon-btn" (click)="closeCommentSheet()"><i class="ri-close-line"></i></button>
    </div>
    <div class="sca-modal-body sca-comment-list">
      <ng-container *ngIf="commentsLoading && comments.length === 0">
        <div class="sca-comment-row" *ngFor="let i of [1,2,3]">
          <div class="sca-skeleton sca-skeleton-circle sca-comment-avatar"></div>
          <div class="sca-comment-bubble">
            <div class="sca-skeleton sca-skeleton-line sca-skeleton-line-title"></div>
            <div class="sca-skeleton sca-skeleton-line sca-skeleton-line-sub"></div>
          </div>
        </div>
      </ng-container>
      <div class="sca-comment-row" *ngFor="let c of comments">
        <div class="st-avatar sca-comment-avatar">{{ (c.commentByUserName || 'U').charAt(0) }}</div>
        <div class="sca-comment-bubble">
          <ng-container *ngIf="editingCommentId !== c.commentId">
            <div class="sca-comment-author">{{ c.commentByUserName || ('userFallback' | translate) }}</div>
            <div class="sca-comment-text">{{ c.comment }}</div>
          </ng-container>
          <div class="sca-comment-edit-row" *ngIf="editingCommentId === c.commentId">
            <input type="text" class="sca-comment-edit-input" [(ngModel)]="editingCommentText" (keyup.enter)="saveEditedComment()" />
            <button class="sca-icon-btn" (click)="saveEditedComment()"><i class="ri-check-line"></i></button>
            <button class="sca-icon-btn" (click)="cancelEditComment()"><i class="ri-close-line"></i></button>
          </div>
        </div>
        <div class="sca-comment-actions" *ngIf="editingCommentId !== c.commentId && (canEditComment(c) || canDeleteComment(c))">
          <button class="sca-icon-btn" *ngIf="canEditComment(c)" (click)="startEditComment(c)"><i class="ri-pencil-line"></i></button>
          <button class="sca-icon-btn" *ngIf="canDeleteComment(c)" (click)="deleteComment(c)"><i class="ri-delete-bin-line"></i></button>
        </div>
      </div>
      <div class="st-empty-state" *ngIf="!commentsLoading && comments.length === 0">{{ 'noCommentsYet' | translate }}</div>
      <div class="sca-load-more" *ngIf="commentHasMore && comments.length">
        <button class="st-btn st-btn-secondary" [disabled]="commentsLoading" (click)="loadMoreComments()">
          {{ (commentsLoading ? 'loadingEllipsis' : 'loadMore') | translate }}
        </button>
      </div>
    </div>
    <div class="sca-modal-foot sca-comment-input-row" *ngIf="createCommentEnabled">
      <input type="text" placeholder="{{ 'writeACommentPlaceholder' | translate }}" [(ngModel)]="newComment" (keyup.enter)="submitComment()" />
      <button class="st-btn st-btn-primary" (click)="submitComment()"><i class="ri-send-plane-line"></i></button>
    </div>
  </div>
</div>

<!-- In-app media / link lightbox — never navigates the user away -->
<div class="sca-lightbox-overlay" *ngIf="showLightbox" (click)="closeLightbox()">
  <button class="sca-lightbox-close" (click)="closeLightbox()"><i class="ri-close-line"></i></button>
  <div class="sca-lightbox-content" (click)="$event.stopPropagation()">
    <iframe *ngIf="lightboxType === 'document'" [src]="lightboxSafeUrl" class="sca-lightbox-frame"></iframe>
    <iframe *ngIf="lightboxType === 'link'" [src]="lightboxSafeUrl" class="sca-lightbox-frame"></iframe>
  </div>
</div>

<!-- Full-post view — opened from the collage. Shows the post's author,
     time and text like the feed card, plus every attached image/video
     stacked in a scrollable list. Clicking a media item opens a proper
     full-screen preview of just that item. -->
<div class="sca-gallery-overlay" *ngIf="showGallery" (click)="closeGallery()">
  <div class="sca-gallery-panel" (click)="$event.stopPropagation()">
    <div class="sca-gallery-head">
      <div class="sca-post-head sca-gallery-post-head" *ngIf="galleryPost">
        <div class="st-avatar sca-post-avatar">
          <img *ngIf="postAuthorImage(galleryPost)" [src]="postAuthorImage(galleryPost)" alt="" />
          <ng-container *ngIf="!postAuthorImage(galleryPost)">{{ postAuthor(galleryPost).charAt(0) }}</ng-container>
        </div>
        <div class="st-list-text">
          <div class="sca-post-title">{{ postAuthor(galleryPost) }}</div>
          <div class="sca-post-meta">{{ 'postedLabel' | translate }} {{ postTime(galleryPost) }}</div>
        </div>
      </div>
      <button class="sca-icon-btn" (click)="closeGallery()"><i class="ri-close-line"></i></button>
    </div>
    <div class="sca-gallery-scroll">
      <div class="sca-post-text sca-gallery-post-text" *ngIf="galleryPost" [innerHTML]="postBodyHtml(galleryPost)"></div>
      <div class="sca-gallery-row" *ngFor="let m of galleryItems" (click)="openMediaPreview(m, $event)">
        <img *ngIf="m.mediaType === 'IMAGE'" [src]="m.mediaUrl" class="sca-gallery-row-media" alt="" />
        <video *ngIf="m.mediaType === 'VIDEO'" [src]="m.mediaUrl" class="sca-gallery-row-media"></video>
      </div>
    </div>
  </div>
</div>

<!-- Full-screen preview of a single media item, opened from the post view above -->
<div class="sca-lightbox-overlay" *ngIf="showMediaPreview" (click)="closeMediaPreview()">
  <button class="sca-lightbox-close" (click)="closeMediaPreview()"><i class="ri-close-line"></i></button>
  <div class="sca-lightbox-content" (click)="$event.stopPropagation()">
    <img *ngIf="previewItem?.mediaType === 'IMAGE'" [src]="previewItem?.mediaUrl" class="sca-lightbox-image" alt="" />
    <video *ngIf="previewItem?.mediaType === 'VIDEO'" [src]="previewItem?.mediaUrl" class="sca-lightbox-video" controls autoplay></video>
  </div>
</div>
